import React, {useEffect} from 'react';
import axios from 'axios';
import {request} from "./requestStore";

let verbiageResetTimeout = null;

const OOBA_MODAL_LOADING = 'LOADING';
const OOBA_MODAL_PUSH = 'PUSH';

/*** Any updates need to be reflected in challenge.js - updateLegacyOobaModalContent() as well ***/
const updateOobaModalContent = (mode, code, shouldCleanup) => {
    const processingContent = $('#ooba-processing-content');
    const pushContent = $('#ooba-push-content');

    // if previous timeout exists, cancel it
    if (verbiageResetTimeout) {
        clearTimeout(verbiageResetTimeout);
        verbiageResetTimeout = null;
    }

    if (mode === OOBA_MODAL_PUSH) {
        if (code)
            $('#push-number').text(code);
        processingContent.addClass('cb-hide');
        pushContent.removeClass('cb-hide');
    } else {
        pushContent.addClass('cb-hide');
        processingContent.removeClass('cb-hide');
    }

    if (shouldCleanup)
        verbiageResetTimeout = setTimeout(() => updateOobaModalContent(OOBA_MODAL_LOADING), 61500);
}

/*** Any updates need to be reflected in challenge.js - requestOobDirection() as well ***/
const requestOobDirection = (setOobaType) => {
    verbiageResetTimeout = null
    updateOobaModalContent(OOBA_MODAL_LOADING);
    request.post('/eci/event/direction')
        .send({_csrf: CSRFToken})
        .type('json')
        .end((err, res) => {
            if(res.body.data) {
                if (setOobaType) setOobaType(res.body.data.type);
                if(res.body.data.type === "KEY")
                    webauthnChallenge(res.body.data)
                else if(res.body.data.type === "PUSH") {
                    updateOobaModalContent(OOBA_MODAL_PUSH, res.body.data.code, true)
                }
            }
        })
};

const requestLoginOobDirection = (setOobaType) => {
    verbiageResetTimeout = null
    updateOobaModalContent(OOBA_MODAL_LOADING);
    request.post('/eci/event/login/direction')
        .send({_csrf: CSRFToken})
        .type('json')
        .end((err, res) => {
            if(res.body.data) {
                if (setOobaType) setOobaType(res.body.data.type);
                if(res.body.data.type === "KEY")
                    webauthnChallenge(res.body.data)
                else if(res.body.data.type === "PUSH") {
                    updateOobaModalContent(OOBA_MODAL_PUSH, res.body.data.code, true)
                }
            }
        })
};

/*** Any updates need to be reflected in challenge.js - webauthnChallenge() as well ***/
const webauthnChallenge = (response) => {
    const challengeObject = { credentialId: response.credentialId, challenge: response.challenge, extensions: response.extensions };

    // Convert activation object's challenge nonce from string to binary
    challengeObject.challenge = CryptoUtil.strToBin(challengeObject.challenge);
    challengeObject.allowCredentials = [{
        id: CryptoUtil.strToBin(challengeObject.credentialId),
        type: 'public-key',
        transports: ['usb', 'nfc']
    }];
    const rp = {
        id: response.rpId,
        name: response.rpName
    }
    challengeObject.rp = rp
    challengeObject.rpId = response.rpId

    // Call the WebAuthn javascript API to get signed assertion from the WebAuthn authenticator
    navigator.credentials
        .get({
            publicKey: challengeObject
        })
        .then((assertion) => {
            // Get the client data, authenticator data, and signature data from callback result, convert from binary to string
            const clientData = CryptoUtil.binToStr(assertion.response.clientDataJSON);
            const authenticatorData = CryptoUtil.binToStr(assertion.response.authenticatorData);
            const signatureData = CryptoUtil.binToStr(assertion.response.signature);
            postWebauthnAnswer({eventId: response.eventId, clientData, signatureData, authenticatorData})
        })
        .catch((error) => {
            //failure/cancel
            console.log(error)
            postWebauthnAnswer({eventId: response.eventId, canceled: true})
        });
};


/*** Any updates need to be reflected in challenge.js - postWebauthnAnswer() as well ***/
const postWebauthnAnswer = (data) => {
    request.post('/eci/oob/webauthn/answer')
        .type('json')
        .send(data)
        .send({_csrf: CSRFToken})
        .end((err, res) => {
            console.log(res.body)
        })
};

export const showOOBAModal = (setOobaType) => {
    updateOobaModalContent(OOBA_MODAL_LOADING);
    requestOobDirection(setOobaType);
    $('#oobaModal').cbModal('show');
};

export const showLoginOOBAModal = (setOobaType) => {
    updateOobaModalContent(OOBA_MODAL_LOADING);
    requestLoginOobDirection(setOobaType);
    $('#oobaModal').cbModal('show');
};

export const hideOOBAModal = () => {
    $('#oobaModal').cbModal('hide');
};

export const showOOBAErrorModal = () => {
    $('#oobaErrorModal').cbModal('show');
};

export const hideOOBAErrorModal = () => {
    $('#oobaErrorModal').cbModal('hide');
};

export const initAxios = () => {
    axios.interceptors.response.use(function (response) {
        sendMessageToParent("ping");
        return response
    }, function (err) {
        sendMessageToParent("ping");
        return err
    })
};

export const maskAccountNumber = (acct) => {
    let new_number = acct.number;

    if(!new_number)
        new_number = acct.nickName || acct;

    if(typeof new_number === 'object')
        new_number = "Account not found."

    return <>
        { acct.key != 0 ? (
            <span className="cb-text-truncate" style={{width: '100%'}}>
                <i className="cb-icon icon-more_horiz"></i>{new_number}
            </span>
        ) : (
            <span className="wrap-line" style={{width: '100%'}}>{new_number}</span>
        )}
    </>
};

export const ie = (function() {
    let ua = window.navigator.userAgent;
    let version = -1;

    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        version = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        let rv = ua.indexOf('rv:');
        version =  parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        version = parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return {
        version: version,
        isIe: version !== -1
    };
})();

export const mobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
};

export const maskAccountNumberAscii = (acct) => {
    let new_number = acct.number;

    if(!new_number) {
        new_number = acct.nickName || acct;
    }

    if(new_number.charAt(0).toUpperCase() === 'X') {
        new_number = new_number.substring(1);
    }

    if(acct.key != 0) {
        new_number = String.fromCharCode(8230) + ' ' + new_number;
    }

    return new_number;
};

export const getObjectByString = (obj, string) => {
    string = string.replace(/\[(\w+)]/g, '.$1'); // convert indexes to properties
    string = string.replace(/^\./, '');           // strip a leading dot
    let arrayProps = string.split('.');
    for (let i = 0; i < arrayProps.length; i++) {
        let tempProp = arrayProps[i];
        if (tempProp in obj) {
            obj = obj[tempProp];
            if (obj === null) {
                return null;
            }
        } else {
            return null;
        }
    }
    return obj;
};


export const getObjectByArray = (obj, arr) => {
    let retVal = null;

    for(var arrI=0; arrI < arr.length; arrI++) {
        retVal = getObjectByString(obj, arr[arrI]);
        if(retVal) {
            break;
        }
    }

    return retVal;
};

export const convertListToQueryParam = (list, paramName) => {
    if (list == null || list.length == 0)
        return "";
    let queryParams = "";
    for (let i = 0; i < list.length; i++)
        queryParams += "&" + paramName + "=" + list[i];

    return queryParams;
};

export const getApprovalStatus = (status) => {
    switch (status) {
        case 'WILLPROCESSON':
            status = 'Scheduled';
            break;
        case 'POSTEDON':
            status = 'Completed';
            break;
        case 'DELETED':
        case 'CANCELEDON':
            status = 'Deleted';
            break;
        case 'PendingApproval':
        case 'APPROVAL_PENDING':
            status = 'Approval Pending';
            break;
        case 'APPROVAL_FAILED':
            status = 'Approval Failed';
            break;
        case 'APPROVAL_REJECTED':
            status = 'Approval Rejected';
            break;
        case 'ADDED':
            status = 'New';
            break;
        case 'MODIFIED':
            status = 'Modified';
            break;
        case 'TEMPLATE':
        case 'TEMPLATE_MODIFIED':
            status = 'Template Modified';
            break;
        case 'ACTIVE':
            status = 'Active';
            break;
        case 'CLOSED':
            status = 'Inactive';
            break;
        case 'FAILEDON':
        case 'FAILED':
            status = 'Failed';
            break;
        default:
            //status = ''
            break;
    }
    return status
};

export const getBatchGender = (gender) => {
    switch (gender.trim()) {
        case 'CR':
            gender = 'Credit';
            break;
        case 'DR':
            gender = 'Debit';
            break;
        case 'CR/DR':
            gender = 'Mixed';
            break;
        default:
            gender = '';
            break;
    }
    return gender
};

export const getForeignExchange = (code) => {
    switch (code) {
        case 'FV':
            code = 'Fixed-to-Variable';
            break;
        case 'VF':
            code = 'Variable-to-Fixed';
            break;
        case 'FF':
            code = 'Fixed-to-Fixed';
            break;
        default:
            code = '';
            break;
    }
    return code
};

export const getUrlParams = () => {
    var urlParams;
    var match,
        pl     = /\+/g,  // Regex for replacing addition symbol with a space
        search = /([^&=]+)=?([^&]*)/g,
        decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
        query  = window.location.search.substring(1);

    urlParams = {};
    while (match = search.exec(query))
        urlParams[decode(match[1])] = decode(match[2]);

    return urlParams;
};

export const spinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 32 // The radius of the inner circle
    , scale: 1 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#006f51' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

export const transferSpinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 32 // The radius of the inner circle
    , scale: 1 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#006f51' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '55%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

export const wiresTabSpinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 32 // The radius of the inner circle
    , scale: 1 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#006f51' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '0%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'relative' // Element positioning
};

export const mfaSpinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 32 // The radius of the inner circle
    , scale: 1 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#006f51' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '55%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

export const inBtnspinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 19 // The length of each line
    , width: 8 // The line thickness
    , radius: 30 // The radius of the inner circle
    , scale: .25 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#ffffff' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '80%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'relative' // Element positioning
};

export const buttonSpinnerConfig = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 28 // The radius of the inner circle
    , scale: .25 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#fff' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '0%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'relative' // Element positioning
};

export const positivePayLoading = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 8 // The line thickness
    , radius: 32 // The radius of the inner circle
    , scale: 0.3 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    // , color: '#6ab244' // #rgb or #rrggbb or array of colors
    , color: '#f9f9f9'
    , opacity: 0.65 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

export const bankInfoSpinner = {
    lines: 13 // The number of lines to draw
    , length: 24 // The length of each line
    , width: 11 // The line thickness
    , radius: 32 // The radius of the inner circle
    , scale: 0.3 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    // , color: '#6ab244' // #rgb or #rrggbb or array of colors
    , color: '#666'
    , opacity: 0.65 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '50%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'absolute' // Element positioning
};

export const unsavedChangesSpinner = {
    lines: 16 // The number of lines to draw
    , length: 32 // The length of each line
    , width: 8 // The line thickness
    , radius: 40 // The radius of the inner circle
    , scale: .33 // Scales overall size of the spinner
    , corners: .8 // Corner roundness (0..1)
    , color: '#006f51' // #rgb or #rrggbb or array of colors
    , opacity: 0.25 // Opacity of the lines
    , rotate: 0 // The rotation offset
    , direction: 1 // 1: clockwise, -1: counterclockwise
    , speed: 1.5 // Rounds per second
    , trail: 60 // Afterglow percentage
    , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
    , zIndex: 2e9 // The z-index (defaults to 2000000000)
    , className: 'spinner' // The CSS class to assign to the spinner
    , top: '100%' // Top position relative to parent
    , left: '50%' // Left position relative to parent
    , shadow: false // Whether to render a shadow
    , hwaccel: false // Whether to use hardware acceleration
    , position: 'relative' // Element positioning
};

export const AccountHistoryUrl = "/eci/accountInquiry/accountHistory";
export const AccountHistoryExportUrl = "/eci/accountInquiry/accountHistory/export";
export const AccountHistoryReportStreamUrl = "/eci/accountInquiry/accountHistory/stream";
